export default __webpack_public_path__ + "static/media/haraka_logo.01663a0d.jpeg";